import { FieldDataType } from 'src/app/models/module-structure';
export interface ShoppingProducts {
  ROW: number;
  RowClass: string;
  ItemCode: string;
  ItemName: string;
  Image?: any;
  SUomEntry: number;
  SelectedQuantity?: any;
  Configurable?: string;
  JsonData?: string;
  Quantity: number;
  FreeQuantity?: any;
  OnHand: number;
  Discount?: any;
  PriceAfDis: number;
  LineNum: number;
  Unit?: any;
  WhsName?: any;
  Currency: string;
  Price: number;
  LineTotal: number;
  ItemTemplateHtml: string;
  MinOrdrQty: number;
  MultOrdQty: number;
  SerialEnabled: string;
  VariantEnabled: string;
  WarrentyEnabled: string;
  WarrentyOptions: string | WarrantyOption[] | null;
  WarrantyCode: string;
  WarrantyLabel: string;
  WarrantyPrice: number;
  WarrantyTaxRate: number;
  WarehouseCode?: string;
  WarehouseName?: string;
  ManualWhs?: boolean;

  SerialType: string;
  SerialOptions: string;
  CustomVariant: string;
}

export interface WarrantyOption {
  Code: string;
  Label: string;
  //Quantity: number;
  Price: number;
  TaxRate: number;
  //Total: number;
}

export interface ShoppingProductsParameters {
  CardCode: string;
  Properties: any[];
  CurrentNav: Array<CurrentNav>;
  CurrentPage: number;
  DbShoppingCartId: string;
  PageCount: string;
  ShoppingCartId: string;
  TableFilter: string;
  searchValue: string;
  additionalWhereClause?: string;
  productFetcherCounter?: number;
}

export interface CurrentNav {
  FieldName: string;
  IsProperty: boolean;
  Label: string;
  NavigationOptions: NavigationOptions[];
  PropertyCode?: any;
  TAG?: any;
  FieldId: number;
  AddedByNav?: boolean;
}

export interface NavigationOptions {
  Name: string;
  Count: number;
  Selected: boolean;
  Value: string;
  Level: number;
  Parent: string;
  Sort: string;
  TAG: string;
  ChildrenCount: number;
  Condition: string;
  Hidden?: boolean;
  Children: NavigationOptions[];
}

export interface TableTitles {
  Name: string;
  IsHTML: boolean;
  Searchtype: boolean;
  Title: string;
  Visible: boolean;
  LinkedModule: number;
  Keyname: string;
  Type: FieldDataType;
  Mode: TableTitleMode;
  JscriptOnChange?: any;
  ModuleID: string;
  InDetailsPopupColumn?: any;
  SQLStatementId?: any;
  FilterValue?: any;
  Isexpression?: boolean;
  Expression?: any;
  Width: number;
  FilterType: number;
  FiltersQLStatementId?: any;
  Filterable: boolean;
  Options?: any[];
}

export enum TableTitleMode {
  ReadOnly = 1,
  Editable,
  Addable,
  Both,
}
export enum ColumnSettingType {
  Label = 1,
  Date,
  Price,
  Amount,
  CheckBox,
  RadioButton,
  Hidden,
  DropdownList,
  RichText,
  Image,
  CartQuantity,
  Link,
  Discount,
  SelectionCheckBox,
  Icon,
  Number,
}

// ------------------- Navigation -------------------
export interface NavigationObject {
  ContentEncoding?: any;
  ContentType?: any;
  Data: Data;
  JsonRequestBehavior: number;
  MaxJsonLength?: any;
  RecursionLimit?: any;
}

export interface Data {
  ProductCount: number;
  NavigationData: NavigationData[];
}

export interface NavigationData {
  Label: string;
  FieldName: string;
  NavigationOptions: NavigationOptions[];
  TAG?: any;
  IsProperty: boolean;
  PropertyCode?: any;
  ShowOnTop?: boolean;
  MultiSelection?: boolean;
  SearchText?: string;
  FieldId?: number;
  Menu: NavigationOptions[];
}

export interface DeleteItemParams {
  itemCode: string;
  lineNume: number;
  shippingAddress: string;
  billingAddress: string;
  contactPerson: string;
  docEntry: string;
  cardCode: string;
  year: number;
  month: number;
  day: number;
}

export interface ItemToImport {
  ItemCode: string;
  ItemName: string;
  Quantity: number;
  UomName: string;
  Status?: string;
  ErrMsg?: string;
}
export const defaultTableTitles: TableTitles[] = [
  {
    Name: 'Image',
    IsHTML: false,
    Searchtype: true,
    Filterable: true,
    Title: 'Image',
    Visible: true,
    LinkedModule: null,
    Keyname: null,
    Type: 10,
    Mode: 1,
    JscriptOnChange: null,
    ModuleID: null,
    InDetailsPopupColumn: null,
    SQLStatementId: null,
    FilterValue: null,
    Isexpression: false,
    Expression: null,
    Width: 0,
    FilterType: 0,
    FiltersQLStatementId: null,
  },
  {
    Name: 'ItemCode',
    IsHTML: false,
    Searchtype: true,
    Filterable: true,
    Title: 'Product No.',
    Visible: true,
    LinkedModule: 4,
    Keyname: 'ItemCode',
    Type: 12,
    Mode: 1,
    JscriptOnChange: null,
    ModuleID: '4',
    InDetailsPopupColumn: null,
    SQLStatementId: null,
    FilterValue: null,
    Isexpression: false,
    Expression: null,
    Width: 0,
    FilterType: 0,
    FiltersQLStatementId: null,
  },
  {
    Name: 'ItemName',
    IsHTML: false,
    Searchtype: true,
    Filterable: true,
    Title: 'Description',
    Visible: true,
    LinkedModule: null,
    Keyname: null,
    Type: 1,
    Mode: 1,
    JscriptOnChange: null,
    ModuleID: null,
    InDetailsPopupColumn: null,
    SQLStatementId: null,
    FilterValue: null,
    Isexpression: false,
    Expression: null,
    Width: 0,
    FilterType: 0,
    FiltersQLStatementId: null,
  },
  {
    Name: 'OnHand',
    IsHTML: false,
    Searchtype: true,
    Filterable: true,
    Title: 'In Stock',
    Visible: true,
    LinkedModule: null,
    Keyname: null,
    Type: 1,
    Mode: 1,
    JscriptOnChange: null,
    ModuleID: null,
    InDetailsPopupColumn: null,
    SQLStatementId: null,
    FilterValue: null,
    Isexpression: false,
    Expression: null,
    Width: 0,
    FilterType: 0,
    FiltersQLStatementId: null,
  },
  {
    Name: 'SelectedQuantity',
    IsHTML: false,
    Searchtype: true,
    Filterable: true,
    Title: 'Ordered Qty',
    Visible: true,
    LinkedModule: null,
    Keyname: null,
    Type: 11,
    Mode: 4,
    JscriptOnChange: null,
    ModuleID: null,
    InDetailsPopupColumn: null,
    SQLStatementId: null,
    FilterValue: null,
    Isexpression: false,
    Expression: null,
    Width: 0,
    FilterType: 0,
    FiltersQLStatementId: null,
  },
  {
    Name: 'FreeQuantity',
    IsHTML: false,
    Searchtype: true,
    Filterable: true,
    Title: 'Free Order',
    Visible: false,
    LinkedModule: null,
    Keyname: null,
    Type: 11,
    Mode: 1,
    JscriptOnChange: null,
    ModuleID: null,
    InDetailsPopupColumn: null,
    SQLStatementId: null,
    FilterValue: null,
    Isexpression: false,
    Expression: null,
    Width: 0,
    FilterType: 0,
    FiltersQLStatementId: null,
  },
  {
    Name: 'Unit',
    IsHTML: false,
    Searchtype: true,
    Filterable: true,
    Title: 'UoM',
    Visible: true,
    LinkedModule: null,
    Keyname: null,
    Type: 1,
    Mode: 1,
    JscriptOnChange: null,
    ModuleID: null,
    InDetailsPopupColumn: null,
    SQLStatementId: null,
    FilterValue: null,
    Isexpression: false,
    Expression: null,
    Width: 0,
    FilterType: 0,
    FiltersQLStatementId: null,
  },
  {
    Name: 'WhsName',
    IsHTML: false,
    Searchtype: true,
    Filterable: true,
    Title: 'Whs Name',
    Visible: true,
    LinkedModule: null,
    Keyname: null,
    Type: 1,
    Mode: 1,
    JscriptOnChange: null,
    ModuleID: null,
    InDetailsPopupColumn: null,
    SQLStatementId: null,
    FilterValue: null,
    Isexpression: false,
    Expression: null,
    Width: 0,
    FilterType: 0,
    FiltersQLStatementId: null,
  },
  {
    Name: 'Price',
    IsHTML: false,
    Searchtype: true,
    Filterable: true,
    Title: 'Price Before Dis',
    Visible: true,
    LinkedModule: null,
    Keyname: null,
    Type: 3,
    Mode: 1,
    JscriptOnChange: null,
    ModuleID: null,
    InDetailsPopupColumn: null,
    SQLStatementId: null,
    FilterValue: null,
    Isexpression: false,
    Expression: null,
    Width: 0,
    FilterType: 0,
    FiltersQLStatementId: null,
  },
  {
    Name: 'Discount',
    IsHTML: false,
    Searchtype: true,
    Filterable: true,
    Title: 'Discount',
    Visible: true,
    LinkedModule: null,
    Keyname: null,
    Type: 1,
    Mode: 1,
    JscriptOnChange: null,
    ModuleID: null,
    InDetailsPopupColumn: null,
    SQLStatementId: null,
    FilterValue: null,
    Isexpression: false,
    Expression: null,
    Width: 0,
    FilterType: 0,
    FiltersQLStatementId: null,
  },
  {
    Name: 'PriceAfDis',
    IsHTML: false,
    Searchtype: true,
    Filterable: true,
    Title: 'Price After Dis',
    Visible: true,
    LinkedModule: null,
    Keyname: null,
    Type: 3,
    Mode: 1,
    JscriptOnChange: null,
    ModuleID: null,
    InDetailsPopupColumn: null,
    SQLStatementId: null,
    FilterValue: null,
    Isexpression: false,
    Expression: null,
    Width: 0,
    FilterType: 0,
    FiltersQLStatementId: null,
  },
  {
    Name: 'LineTotal',
    IsHTML: false,
    Searchtype: true,
    Filterable: true,
    Title: 'Line Total',
    Visible: true,
    LinkedModule: null,
    Keyname: null,
    Type: 3,
    Mode: 1,
    JscriptOnChange: null,
    ModuleID: null,
    InDetailsPopupColumn: null,
    SQLStatementId: null,
    FilterValue: null,
    Isexpression: false,
    Expression: null,
    Width: 0,
    FilterType: 0,
    FiltersQLStatementId: null,
  },
];
